module.exports = __webpack_public_path__ + "public/starsreward_chest_open@2x.png";